export default __webpack_public_path__ + "media/images/corporate/hero/lg-65de0d253bf10a1284c4ed23bb7d0da4.webp";